document.addEventListener("DOMContentLoaded", function () {

  let couponCode = document.getElementById("order-coupon-code-input");
  if(couponCode !== null) {
    couponCode.addEventListener("keypress", function(event) {
      if (event.key === "Enter") {
        event.preventDefault();
        let appliedCoupon = document.getElementById('applied-coupon');

        if (!appliedCoupon && couponCode && couponCode.value !== '') {
          let applyCodeWithCheckoutButton = document.getElementById(
            'order-coupon-apply-with-chechout-button'
          );
          applyCodeWithCheckoutButton.click();
        }
      }
    });
  }
})
